/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ArticleDto,
    ArticleDtoFromJSON,
    ArticleDtoToJSON,
} from '../models/ArticleDto';
import {
    type ArticleListItemDto,
    ArticleListItemDtoFromJSON,
    ArticleListItemDtoToJSON,
} from '../models/ArticleListItemDto';
import {
    type ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/ProblemDetails';

export interface ApiCmsArticleIdGetRequest {
    id: string;
}

export interface ApiCmsArticleUrlGetRequest {
    url?: string;
}

/**
 * 
 */
export class CmsApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiCmsArticleIdGet without sending the request
     */
    async apiCmsArticleIdGetRequestOpts(requestParameters: ApiCmsArticleIdGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiCmsArticleIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/cms/article/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiCmsArticleIdGetRaw(requestParameters: ApiCmsArticleIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ArticleDto>> {
        const requestOptions = await this.apiCmsArticleIdGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ArticleDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiCmsArticleIdGet(requestParameters: ApiCmsArticleIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ArticleDto> {
        const response = await this.apiCmsArticleIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiCmsArticleUrlGet without sending the request
     */
    async apiCmsArticleUrlGetRequestOpts(requestParameters: ApiCmsArticleUrlGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['url'] != null) {
            queryParameters['url'] = requestParameters['url'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/cms/article/url`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiCmsArticleUrlGetRaw(requestParameters: ApiCmsArticleUrlGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ArticleDto>> {
        const requestOptions = await this.apiCmsArticleUrlGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ArticleDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiCmsArticleUrlGet(requestParameters: ApiCmsArticleUrlGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ArticleDto> {
        const response = await this.apiCmsArticleUrlGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiCmsArticlesGet without sending the request
     */
    async apiCmsArticlesGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/cms/articles`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiCmsArticlesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ArticleListItemDto>>> {
        const requestOptions = await this.apiCmsArticlesGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ArticleListItemDtoFromJSON));
    }

    /**
     */
    async apiCmsArticlesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ArticleListItemDto>> {
        const response = await this.apiCmsArticlesGetRaw(initOverrides);
        return await response.value();
    }

}
